// extracted by mini-css-extract-plugin
export default {"iconsContainer":"ZNYdy","titleCenter":"P44z9","rightAligned":"dhqKT"};